import { Box } from "@mui/material";
import React from "react";
import TopProducts from "../../components/Products/TopProducts";

const Products = () => {
  return (
    <Box style={{ flex: 1, marginTop: 65 }}>
      <Box style={{ marginBottom: "30px" }}>
        <TopProducts />
      </Box>
    </Box>
  );
};

export default Products;
